// extracted by mini-css-extract-plugin
export default {"container":"Forms_container__GHur4","LoginContainer":"Forms_LoginContainer__GfNBS","submit-btn":"Forms_submit-btn__hUJ-E","form":"Forms_form__d2NiU"};